import { render, staticRenderFns } from "./BulkQuestionnaire.vue?vue&type=template&id=7c6f9dbd"
import script from "./BulkQuestionnaire.vue?vue&type=script&lang=ts"
export * from "./BulkQuestionnaire.vue?vue&type=script&lang=ts"
import style0 from "./BulkQuestionnaire.vue?vue&type=style&index=0&id=7c6f9dbd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports